<template>
  <v-list dark dense>
    <v-list-item-group v-model="selected" active-class="pink--text">
      <v-list-item v-for="(folder, i) in folders" :key="i" @click="selectFolder(folder)">
        <v-list-item-content>
          <v-list-item-title v-text="folder.name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "FolderList",
  data: () => ({
    selected: null,
  }),
  computed: {
    ...mapGetters("mailStore", ["folders"]),
  },
  methods: {
    selectFolder(folder) {
      this.$store.dispatch("mailStore/fetchEmails", folder.name)
    },
  },
}
</script>

<style scoped>
.v-list {
  background-color: transparent !important;
  color: #ffffff !important;
}

.v-list-item {
  border-radius: 4px;
  margin-bottom: 4px;
}

.v-list-item--active {
  background-color: #0d47a1 !important;
}

.v-list-item__title {
  color: #ffffff !important;
}
</style>

.v-list-item--active {
  background-color: #0d47a1 !important;
}

.v-list-item__title {
  color: #ffffff !important;
}
</style>
